import React from 'react';

import { get } from '@lumapps/constants';
import { useSelector } from '@lumapps/redux/react';
import { DelayedSuspense } from '@lumapps/utils/components/DelayedSuspense';

import { isGDPRBannerEnabled } from './ducks/selectors';
import { useGdprBanner } from './hooks/useGdprBanner';

const { isMobileAppWebView } = get();

const LazyGdprBanner = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'gdpr-banner' */
            './components/GdprBanner'
        ),
);

export const GdprBanner = () => {
    const isGDPRBannerFeatureEnabled = useSelector(isGDPRBannerEnabled);

    const { hasUserClosedBanner } = useGdprBanner();

    // Should disable the cookie banner on webviews
    const showGdprBanner = !isMobileAppWebView && !hasUserClosedBanner && isGDPRBannerFeatureEnabled;

    return (
        <DelayedSuspense shouldLoad={showGdprBanner}>
            <LazyGdprBanner />
        </DelayedSuspense>
    );
};
